import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy } from '@angular/core';
import { MdbSidenavModule } from 'mdb-angular-ui-kit/sidenav';
import { Ohlc } from 'src/app/models/ohlc';

@Component({
  selector: 'app-graphbar',
  standalone: true,
  imports: [MdbSidenavModule, CommonModule],
  templateUrl: './graphbar.component.html',
  styleUrl: './graphbar.component.scss'
})
export class GraphbarComponent implements OnDestroy {

  ohlc: Ohlc[] = []
  wBarra: number = 5
  spazioBarre: number = 2
  margineX: number = 15
  margineY: number = 15

  wGrafico: number = 0
  hGrafico: number = 0
  marginLeft: number = 5

  lineaHMouse: SVGLineElement | null = null
  labelHMouse: SVGTextElement | null = null
  lineaVMouse: SVGLineElement | null = null
  labelVMouse: SVGTextElement | null = null
  divCross: HTMLDivElement | null = null

  maxValue: number = 0
  minValue: number = 0

  bAttivaCross: boolean = false

  constructor() {
    window.addEventListener('resize', (e) => this.controllaWindow(e))
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', (e) => this.controllaWindow(e))
  }

  caricaDati(ohlc: Ohlc[]) {
    this.ohlc = ohlc
    let numeroBarre = ohlc.length + this.marginLeft
    let numeroPixel = numeroBarre * (this.wBarra + this.spazioBarre)
    this.wGrafico = numeroPixel
    let hg = numeroPixel * 9 / 16
    this.hGrafico = hg > 600 ? 600 : hg
    let divGrafico = document.getElementById('grafico')
    if (divGrafico) {
      divGrafico.style.width = this.wGrafico.toString() + 'px'
      divGrafico.style.height = this.hGrafico.toString() + 'px'
    }
    let divLabels = document.getElementById('labels')
    if (divLabels) {
      divLabels.style.left = window.innerWidth - 80 - 10 + 'px'
    }
    let maxVal = Math.max(...ohlc.map(el => el.vhigh))
    let minVal = Math.min(...ohlc.map(el => el.vlow))
    this.maxValue = maxVal
    this.minValue = minVal

    let punti = ohlc.map((el, i) => {
      let x = this.calcolaX(i)
      return {
        x1: x - this.wBarra / 2,
        y1: this.calcolaY(minVal, maxVal, el.vopen, this.hGrafico),
        x2: x + this.wBarra / 2,
        y2: this.calcolaY(minVal, maxVal, el.vclose, this.hGrafico),
        x3: x,
        y3: this.calcolaY(minVal, maxVal, el.vhigh, this.hGrafico),
        x4: x,
        y4: this.calcolaY(minVal, maxVal, el.vlow, this.hGrafico),
      }
    })
    this.creaGrafico(punti)
    let dividers = this.dayDividers(ohlc)
    this.drawDayDividers(dividers)
    let labels = this.labelDividers(ohlc)
    this.drawTexts(labels)
    this.creaDonchian(ohlc)
    let scroll = document.getElementById('container-scroll')
    if (scroll) {
      scroll.scrollLeft = this.wGrafico
    }
    console.log((new Date('2024-12-31 03:30:00')).toLocaleString('it-IT'))
    let p1 = this.calcolaPunti('2024-12-31 03:30:00', 156.40)
    let p2 = this.calcolaPunti('2024-12-31 09:45:00', 156.12)
    this.drawTrade(1, p1.x, p1.y, p2.x, p2.y, 'BUY', 'StopLoss')
  }

  attivaPulsante(attivato: boolean) {
    return attivato ? 'btn btn-info btn-sm' : 'btn btn-outline-info btn-sm'
  }

  creaGrafico(punti: any) {
    let svg = document.getElementById('svg-grafico')
    svg?.setAttribute('width', this.wGrafico.toString()) + 'px'
    svg?.setAttribute('height', this.hGrafico.toString()) + 'px'
    let children = Array.from(svg?.children || [])
    children.forEach((el: any) => {
      svg?.removeChild(el)
    })
    punti.forEach((el: any) => {
      svg!.appendChild(this.creaLinea(el.x3, el.y3, el.x4, el.y4))
      svg!.appendChild(this.creaBarra(el.x1, el.y1, el.x2, el.y2))
    })

  }

  creaLinea(x1: number, y1: number, x2: number, y2: number, colore: string = 'gray') {
    let linea = document.createElementNS("http://www.w3.org/2000/svg", "line");
    linea.setAttribute('x1', x1.toString())
    linea.setAttribute('y1', y1.toString())
    linea.setAttribute('x2', x2.toString())
    linea.setAttribute('y2', y2.toString())
    linea.setAttribute('stroke', colore)
    linea.setAttribute('stroke-width', '1')
    return linea
  }

  creaBarra(x1: number, y1: number, x2: number, y2: number) {
    let colore = y1 > y2 ? 'green' : 'red'
    let barra = document.createElementNS("http://www.w3.org/2000/svg", "rect");
    barra.setAttribute('x', y1 < y2 ? x1.toString() : x1.toString())
    barra.setAttribute('y', y1 < y2 ? y1.toString() : y2.toString())
    barra.setAttribute('width', (x2 - x1).toString())
    barra.setAttribute('height', Math.abs(y2 - y1).toString())
    barra.setAttribute('fill', colore)
    return barra
  }

  calcolaPunti(ora: string, valore: number) {
    let id = this.ohlc.findIndex(el => el.ora == ora)
    if (id < 0) return { x: 0, y: 0}

    let x = this.calcolaX(id)
    let y = this.calcolaY(this.minValue, this.maxValue, valore, this.hGrafico)
    return { x: x, y: y }
  }

  calcolaY(min: number, max: number, val: number, h: number) {
    return parseInt((h - ((val - min) / (max - min) * (h - 2 * this.margineY)) - this.margineY).toString())
  }

  calcolaX(i: number) {
    return parseInt((i * (this.wBarra + this.spazioBarre) + this.margineX).toString())
  }

  dayDividers(ohlc: Ohlc[]) {
    let dividers = ohlc.filter((el, i) => {
      if (i == 0) return true
      let d1 = new Date(ohlc[i - 1].ora)
      let d2 = new Date(el.ora)
      el.id = i
      return d1.getDay() != d2.getDay()
    })
    let punti = dividers.map((el, i) => {
      let x = this.calcolaX(el.id)
      return {
        x1: x,
        y1: 0,
        x2: x,
        y2: this.hGrafico
      }
    })
    return punti
  }

  labelDividers(ohlc: Ohlc[]) {
    let dividers = ohlc.filter((el, i) => {
      if (i == 0) return true
      let d1 = new Date(ohlc[i - 1].ora)
      let d2 = new Date(el.ora)
      el.id = i
      return d1.getDay() != d2.getDay()
    })
    let punti = dividers.map((el) => {
      let x = this.calcolaX(el.id)
      return {
        x1: x,
        testo: (new Date(el.ora)).toLocaleDateString()
      }
    })
    return punti
  }

  drawDayDividers(punti: any) {
    let svg = document.getElementById('svg-grafico')
    punti.forEach((el: any) => {
      svg!.appendChild(this.creaLinea(el.x1, el.y1, el.x2, el.y2, 'silver'))
    })
  }

  drawTexts(punti: any) {
    let svg = document.getElementById('svg-grafico')
    let h = svg ? parseInt(svg.getAttribute('height') as unknown as string) - this.margineY : 595
    punti.forEach((el: any) => {
      svg!.appendChild(this.creaTesto(el.x1, h, el.testo, 8, 'black'))
    })
  }

  creaTesto(x: number, y: number, testo: string, fontSize: number = 10, colore: string = 'black') {
    let txt = document.createElementNS("http://www.w3.org/2000/svg", "text");
    txt.setAttribute('x', x.toString())
    txt.setAttribute('y', y.toString())
    txt.setAttribute('font-size', fontSize.toString())
    txt.setAttribute('fill', colore)
    txt.textContent = testo
    return txt
  }

  creaDonchian(ohlc: Ohlc[], step: number = 10) {
    let donMin = []
    let donMax = []
    let maxVal = Math.max(...ohlc.map(el => el.vhigh))
    let minVal = Math.min(...ohlc.map(el => el.vlow))
    for (let i = step; i < ohlc.length; i++) {
      let max = Math.max(...ohlc.slice(i - step, i).map(el => el.vhigh))
      let min = Math.min(...ohlc.slice(i - step, i).map(el => el.vlow))
      let x = this.calcolaX(i)
      let y1 = this.calcolaY(minVal, maxVal, min, this.hGrafico)
      let y2 = this.calcolaY(minVal, maxVal, max, this.hGrafico)
      donMin.push({ x: x, y: y1 })
      donMax.push({ x: x, y: y2 })
    }
    let str1 = ''
    donMin.forEach(element => {
      str1 += element.x + ',' + element.y + ' '
    });
    let str2 = ''
    donMax.forEach(element => {
      str2 += element.x + ',' + element.y + ' '
    });
    let dMin = document.createElementNS("http://www.w3.org/2000/svg", "polyline");
    dMin.setAttribute('points', str1)
    dMin.setAttribute('fill', 'none')
    dMin.setAttribute('stroke', 'red')
    dMin.setAttribute('stroke-width', '1')
    let svg = document.getElementById('svg-grafico')
    svg?.appendChild(dMin)
    let dMax = document.createElementNS("http://www.w3.org/2000/svg", "polyline");
    dMax.setAttribute('points', str2)
    dMax.setAttribute('fill', 'none')
    dMax.setAttribute('stroke', 'green')
    dMax.setAttribute('stroke-width', '1')
    svg?.appendChild(dMax)
  }

  mouseOver(event: any) {
    let x = event.offsetX
    let y = event.offsetY
    let svg = document.getElementById('svg-grafico')
    let svg2 = document.getElementById('svg-labels')
    if (!this.lineaHMouse) {
      this.lineaHMouse = document.createElementNS("http://www.w3.org/2000/svg", "line");
      this.lineaHMouse.setAttribute('x1', '0')
      this.lineaHMouse.setAttribute('y1', y.toString())
      this.lineaHMouse.setAttribute('x2', this.wGrafico ? this.wGrafico.toString() : '0')
      this.lineaHMouse.setAttribute('y2', y.toString())
      this.lineaHMouse.setAttribute('stroke', 'black')
      this.lineaHMouse.setAttribute('stroke-width', '1')
      svg?.appendChild(this.lineaHMouse)
    }
    else {
      this.lineaHMouse.setAttribute('y1', y.toString())
      this.lineaHMouse.setAttribute('y2', y.toString())
    }
    if (!this.labelHMouse) {
      this.labelHMouse = document.getElementById('cross-value') as unknown as SVGTextElement;
      this.labelHMouse.setAttribute('x', '0')
      this.labelHMouse.setAttribute('y', y.toString())
      this.labelHMouse.setAttribute('font-size', '12')
      this.labelHMouse.setAttribute('font-weight', 'bold')
      this.labelHMouse.setAttribute('fill', 'blue')
      let xVal = (this.maxValue - this.minValue) * (this.hGrafico - y) / this.hGrafico + this.minValue
      this.labelHMouse.textContent = xVal.toString()
      svg2?.appendChild(this.labelHMouse)
    } else {
      this.labelHMouse.setAttribute('y', y.toString())
      let xVal = ((this.maxValue - this.minValue) * (this.hGrafico - y) / this.hGrafico + this.minValue).toFixed(4)
      this.labelHMouse.textContent = xVal.toString()
    }
    if (!this.lineaVMouse) {
      this.lineaVMouse = document.createElementNS("http://www.w3.org/2000/svg", "line");
      this.lineaVMouse.setAttribute('x1', x.toString())
      this.lineaVMouse.setAttribute('y1', '0')
      this.lineaVMouse.setAttribute('x2', x.toString())
      this.lineaVMouse.setAttribute('y2', this.hGrafico ? this.hGrafico.toString() : '0')
      this.lineaVMouse.setAttribute('stroke', 'black')
      this.lineaVMouse.setAttribute('stroke-width', '1')
      svg?.appendChild(this.lineaVMouse)
    }
    else {
      this.lineaVMouse.setAttribute('x1', x.toString())
      this.lineaVMouse.setAttribute('x2', x.toString())
    }
    if (!this.labelVMouse) {
      this.labelVMouse = document.createElementNS("http://www.w3.org/2000/svg", 'text') as unknown as SVGTextElement;

      this.labelVMouse.setAttribute('x', x.toString())
      this.labelVMouse.setAttribute('y', '595')
      this.labelVMouse.setAttribute('font-size', '12')
      //this.labelVMouse.setAttribute('font-weight', 'bold')
      this.labelVMouse.setAttribute('fill', 'gray')
      let xVal = parseInt(((x - this.marginLeft) / (this.wBarra + this.spazioBarre)).toFixed(0))
      if (xVal < 0 || xVal >= this.ohlc.length) return
      let ora = (new Date(this.ohlc[xVal].ora)).toLocaleTimeString()
      this.labelVMouse.textContent = ora
      svg?.appendChild(this.labelVMouse)
    } else {
      let xVal = parseInt(((x - this.marginLeft) / (this.wBarra + this.spazioBarre)).toFixed(0)) - 1
      if (xVal < 0 || xVal >= this.ohlc.length) return
      this.labelVMouse.setAttribute('x', x.toString())
      let ora = (new Date(this.ohlc[xVal].ora)).toLocaleTimeString()
      this.labelVMouse.textContent = ora
    }
  }

  controllaWindow(event: any) {
    let divLabels = document.getElementById('labels')
    if (divLabels) {
      divLabels.style.left = window.innerWidth - 80 - 10 + 'px'
    }
  }

  attivaCross() {
    this.bAttivaCross = !this.bAttivaCross
    if (!this.divCross) {
      this.divCross = document.getElementById('divGrafico') as HTMLDivElement
    }
    if (this.bAttivaCross) {
      this.divCross.style.backgroundColor = 'transparent'
      this.divCross.style.zIndex = '1000'
      this.divCross.style.cursor = 'crosshair'
      this.divCross.addEventListener('mousemove', (e) => this.mouseOver(e))
    } else {
      this.divCross?.removeEventListener('mousemove', (e) => this.mouseOver(e))
      this.divCross!.style.cursor = 'default'
      this.divCross!.style.backgroundColor = 'white'
      this.divCross!.style.zIndex = '0'
      let svg = document.getElementById('svg-grafico')
      svg?.removeChild(this.lineaHMouse as Node)
      svg?.removeChild(this.lineaVMouse as Node)
      this.labelHMouse!.textContent = ''
      this.labelVMouse!.textContent = ''
      this.lineaHMouse = null
      this.lineaVMouse = null
    }
  }

  drawTrade(id: number, x1: number, y1: number, x2: number, y2: number, text1: string, text2: string) {
    
    let linea = document.createElementNS("http://www.w3.org/2000/svg", "path");
    let dPath = `M ${x1} ${y1} L ${x2} ${y2}`;
    linea.setAttribute('d', dPath)
    linea.setAttribute('stroke', 'blue')
    linea.setAttribute('stroke-width', '1')
    linea.setAttribute('fill', 'none')

    let testo1 = document.createElementNS("http://www.w3.org/2000/svg", 'text') as unknown as SVGTextElement;
    testo1.setAttribute('x', x1.toString())
    testo1.setAttribute('y', y1.toString())
    testo1.setAttribute('font-size', '12')
    testo1.setAttribute('font-weight', 'bold')
    testo1.setAttribute('fill', 'gray')
    testo1.textContent = text1

    let testo2 = document.createElementNS("http://www.w3.org/2000/svg", 'text') as unknown as SVGTextElement;
    testo2.setAttribute('x', (x2-30).toString())
    testo2.setAttribute('y', (y2).toString())
    testo2.setAttribute('font-size', '12')
    testo2.setAttribute('font-weight', 'bold')
    testo2.setAttribute('fill', 'gray')
    testo2.textContent = text2

    let g = document.createElementNS("http://www.w3.org/2000/svg", "g");
    g.setAttribute('id', 'trade'+id.toString())
    g.appendChild(linea)
    g.appendChild(testo1)
    g.appendChild(testo2)

    let svg = document.getElementById('svg-grafico')
    svg?.appendChild(g)
  }

}
